<template>

    <Start :lang="lang" />
    <Navbar :lang="lang" />
    <Intro :lang="lang"/>

    <div class="votebanner">
        <h1>VOTE FOR YAN WANG!</h1>
    </div>

    <Volunteer :lang="lang" />
    <div class="contactLocator"></div>
    <Contact :lang="lang"/>

    
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import Start from '@/components/home/Start.vue'
import Intro from '@/components/home/Intro.vue'
import Volunteer from '@/components/home/Volunteer.vue'
import Contact from '@/components/home/Contact.vue'
import translate from "@/assets/translate.json"

export default {
  name: 'HomeView',
  components: {
    Navbar,
    Start,
    Intro,
    Volunteer,
    Contact,
  },
  data(){
      return{
          translate: translate.intro,
          processing: false,
          showMessage: false,
          messageDuration: 0
      }
  }, 
  props:{
    lang: 0,
  },
  methods: {

      navTo(link){
          this.$router.push(link);
      },

      contactScroll(){
          document.querySelector('.contactLocator').scrollIntoView({
            behavior: 'smooth'
        });
      },
  },

}
</script>
<style lang="scss" scoped>
@import "@/assets/styles.scss";

.locator{
    height: 0;
    width: 100%;
}

.contact{
    height: fit-content;
    background-color: $text-color;
    padding: 40px 0px;

    & > h1{
        font-size: 3.13em;
        padding: 0px 0px 10px 0px;
        color: white;
        text-align: center;
        
    }

    &__email{
        width: 60%;
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px;
        font-size: 1.2em;
        padding: 15px 30px;
        border: solid 3px white;
        outline: none;
        background: none;
        color: white;

    }

    & > textarea{
        width: 60%;
        height: 200px;
        font-size: 1.2em;
        padding: 20px;
        font-family: Arial, Helvetica, sans-serif;
        margin-top: 20px;
        border: solid 3px white;
        outline: none;
        background: none;
        color: white;
    }

    &__submit{
        @include button;
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px;
        border: none;
        
        background-color: $primary-color;

        &:hover{
            background-color: #fce3a3;
            cursor: pointer;
        }
    }

    &__info{
        display: flex;
        flex-direction: column;
        font-size: 1.2em;
        color: $primary-color;
        margin-left: auto;
        margin-right: auto;
        margin-top: 40px;
        width: 60%;
        &--num{
     
        }
        &--email{
            margin-top: 10px;
        }
    }

   
}

</style>
